<div class="row mobile-footer">
  <div class="copyright">
    <p>Copyright © Tidal 2021</p>
  </div>
</div>
<div class="row bottom-space"></div>
